// Login
export const LoginData = {
  en: {
    welcomeBack: "Welcome back",
    loginText: "Login to your LMS account",
    identifierLabel: "Email, Username, or Phone",
    identifierPlaceholder: "Enter your email, username, or phone",
    passwordLabel: "Password",
    forgotPassword: "Forgot your password?",
    stayLoggedIn: "Stay logged in",
    signIn: "Sign In",
    orContinueWith: "Or continue with",
    loginWithGoogle: "Login with Google",
    noAccount: "Don't have an account?",
    signUp: "Sign up",
    termsOfService: "Terms of Service",
    privacyPolicy: "Privacy Policy",
  },
  ar: {
    welcomeBack: "مرحبًا بعودتك",
    loginText: "قم بتسجيل الدخول إلى حسابك في LMS",
    identifierLabel: "البريد الإلكتروني أو اسم المستخدم أو الهاتف",
    identifierPlaceholder:
      "أدخل بريدك الإلكتروني أو اسم المستخدم أو رقم الهاتف",
    passwordLabel: "كلمة المرور",
    forgotPassword: "هل نسيت كلمة المرور؟",
    stayLoggedIn: "البقاء متصلاً",
    signIn: "تسجيل الدخول",
    orContinueWith: "أو تابع باستخدام",
    loginWithGoogle: "تسجيل الدخول باستخدام Google",
    noAccount: "ليس لديك حساب؟",
    signUp: "سجل",
    termsOfService: "شروط الخدمة",
    privacyPolicy: "سياسة الخصوصية",
  },
  fr: {
    welcomeBack: "Content de vous revoir",
    loginText: "Connectez-vous à votre compte LMS",
    identifierLabel: "Email, Nom d'utilisateur ou Téléphone",
    identifierPlaceholder: "Entrez votre email, nom d'utilisateur ou téléphone",
    passwordLabel: "Mot de passe",
    forgotPassword: "Mot de passe oublié ?",
    stayLoggedIn: "Rester connecté",
    signIn: "Se connecter",
    orContinueWith: "Ou continuez avec",
    loginWithGoogle: "Se connecter avec Google",
    noAccount: "Vous n'avez pas de compte ?",
    signUp: "S'inscrire",
    termsOfService: "Conditions d'utilisation",
    privacyPolicy: "Politique de confidentialité",
  },
};

// Register
export const RegisterData = {
  en: {
    createAccount: "Create an account",
    signUp: "Sign up for your LMS account",
    name: "Name*",
    email: "Email*",
    password: "Password*",
    confirmPassword: "Confirm Password*",
    username: "Username",
    phone: "Phone",
    signUpButton: "Sign Up",
    orContinueWith: "Or continue with",
    loginWithGoogle: "Login with Google",
    alreadyHaveAccount: "Already have an account?",
    logIn: "Log in",
    termsAndConditions: "Terms of Service",
    privacyPolicy: "Privacy Policy",
  },
  ar: {
    createAccount: "إنشاء حساب",
    signUp: "اشترك في حساب LMS الخاص بك",
    name: "الاسم*",
    email: "البريد الإلكتروني*",
    password: "كلمة المرور*",
    confirmPassword: "تأكيد كلمة المرور*",
    username: "اسم المستخدم",
    phone: "الهاتف",
    signUpButton: "سجل",
    orContinueWith: "أو تابع باستخدام",
    loginWithGoogle: "تسجيل الدخول باستخدام Google",
    alreadyHaveAccount: "هل لديك حساب بالفعل؟",
    logIn: "تسجيل الدخول",
    termsAndConditions: "شروط الخدمة",
    privacyPolicy: "سياسة الخصوصية",
  },
  fr: {
    createAccount: "Créer un compte",
    signUp: "Inscrivez-vous pour votre compte LMS",
    name: "Nom*",
    email: "E-mail*",
    password: "Mot de passe*",
    confirmPassword: "Confirmer le mot de passe*",
    username: "Nom d'utilisateur",
    phone: "Téléphone",
    signUpButton: "S'inscrire",
    orContinueWith: "Ou continuez avec",
    loginWithGoogle: "Se connecter avec Google",
    alreadyHaveAccount: "Vous avez déjà un compte ?",
    logIn: "Se connecter",
    termsAndConditions: "Conditions d'utilisation",
    privacyPolicy: "Politique de confidentialité",
  },
};

// ForgetPassword
export const ForgetPasswordData = {
  en: {
    title: "Forgot Password",
    subtitle: "Enter your email to reset your password",
    emailLabel: "Email",
    emailPlaceholder: "m@example.com",
    resetButton: "Reset Password",
    rememberPassword: "Remember your password?",
    backToLogin: "Back to Login",
  },
  fr: {
    title: "Mot de passe oublié",
    subtitle: "Entrez votre email pour réinitialiser votre mot de passe",
    emailLabel: "E-mail",
    emailPlaceholder: "m@exemple.com",
    resetButton: "Réinitialiser le mot de passe",
    rememberPassword: "Vous vous souvenez de votre mot de passe ?",
    backToLogin: "Retour à la connexion",
  },
  ar: {
    title: "نسيت كلمة المرور",
    subtitle: "أدخل بريدك الإلكتروني لإعادة تعيين كلمة المرور",
    emailLabel: "البريد الإلكتروني",
    emailPlaceholder: "m@example.com",
    resetButton: "إعادة تعيين كلمة المرور",
    rememberPassword: "هل تذكر كلمة المرور؟",
    backToLogin: "العودة إلى تسجيل الدخول",
  },
};

// ResetPassword
export const ResetPasswordData = {
  en: {
    newPasswordLabel: "New Password",
    confirmPasswordLabel: "Confirm New Password",
    newPasswordPlaceholder: "Enter your new password",
    confirmPasswordPlaceholder: "Confirm your new password",
    resetPasswordButton: "Reset Password",
  },
  fr: {
    newPasswordLabel: "Nouveau mot de passe",
    confirmPasswordLabel: "Confirmer le nouveau mot de passe",
    newPasswordPlaceholder: "Entrez votre nouveau mot de passe",
    confirmPasswordPlaceholder: "Confirmez votre nouveau mot de passe",
    resetPasswordButton: "Réinitialiser le mot de passe",
  },
  ar: {
    newPasswordLabel: "كلمة المرور الجديدة",
    confirmPasswordLabel: "تأكيد كلمة المرور الجديدة",
    newPasswordPlaceholder: "أدخل كلمة المرور الجديدة",
    confirmPasswordPlaceholder: "تأكيد كلمة المرور الجديدة",
    resetPasswordButton: "إعادة تعيين كلمة المرور",
  },
};

// CheckCode
export const CheckCodeData = {
  en: {
    title: "Reset Your Password",
    subtitleCodeSuccess: "Enter your new password",
    subtitleEnterCode: "Enter the code you received",
    resendCode: "Resend Code",
    submitCode: "Submit Code",
  },
  fr: {
    title: "Réinitialiser votre mot de passe",
    subtitleCodeSuccess: "Entrez votre nouveau mot de passe",
    subtitleEnterCode: "Entrez le code que vous avez reçu",
    resendCode: "Renvoyer le code",
    submitCode: "Soumettre le code",
  },
  ar: {
    title: "إعادة تعيين كلمة المرور",
    subtitleCodeSuccess: "أدخل كلمة المرور الجديدة الخاصة بك",
    subtitleEnterCode: "أدخل الرمز الذي تلقيته",
    resendCode: "إعادة إرسال الرمز",
    submitCode: "إرسال الرمز",
  },
};

// Header
export const HeaderData = {
  en: {
    academyName: "Naser Academy",
    register: "Register",
    login: "Login",
  },
  ar: {
    academyName: "أكاديمية ناصر",
    register: "تسجيل",
    login: "تسجيل الدخول",
  },
  fr: {
    academyName: "Académie Naser",
    register: "S'inscrire",
    login: "Se connecter",
  },
};

// Sidebar
export const SidebarData = {
  en: {
    logoName: "Ali Academy",
    dashboard: "Dashboard",
    overview: "Overview",
    teacherManagement: "Teacher Management",
    categories: "Categories",
    courses: "Courses",
    myCourses: "My Courses",
    coursesWatched: "Courses I watched",
    completedCourses: "Completed courses",
    currentCourses: "My current courses",
    myLectures: "My Lectures",
    schedule: "Schedule",
    community: "Community",
    invoices: "Invoices",
    past: "Past",
    current: "Current",
    upcoming: "Upcoming",
    settings: "Settings",
    logout: "Logout",
    noSubCategory: "There is no Sub Categories",
    noCategory: "There is no Categories",
    noCourse: "There is no Courses",
    noLevel: "There is no Levels",
  },
  ar: {
    logoName: "أكاديمية علي",
    dashboard: "لوحة التحكم",
    overview: "نظرة عامة",
    teacherManagement: "إدارة المعلمين",
    categories: "الفئات",
    courses: "الدورات",
    myCourses: "دوراتي",
    coursesWatched: "الدورات التي شاهدتها",
    completedCourses: "الدورات المكتملة",
    currentCourses: "دوراتي الحالية",
    myLectures: "محاضراتي",
    schedule: "الجدول",
    community: "المجتمع",
    invoices: "الفواتير",
    past: "الماضية",
    current: "الحالية",
    upcoming: "القادمة",
    settings: "الإعدادات",
    logout: "تسجيل الخروج",
    noSubCategory: "لا يوجد فئات فرعية",
    noCategory: "لا يوجد فئات",
    noCourse: "لا يوجد كورسات",
    noLevel: "لا يوجد مستويات",
  },
  fr: {
    logoName: "Académie Ali",
    dashboard: "Tableau de bord",
    overview: "Vue d'ensemble",
    teacherManagement: "Gestion des enseignants",
    categories: "Catégories",
    courses: "Cours",
    myCourses: "Mes cours",
    coursesWatched: "Cours que j'ai regardés",
    completedCourses: "Cours terminés",
    currentCourses: "Mes cours en cours",
    myLectures: "Mes conférences",
    schedule: "Emploi du temps",
    community: "Communauté",
    invoices: "Factures",
    past: "Passé",
    current: "Actuel",
    upcoming: "À venir",
    settings: "Paramètres",
    logout: "Déconnexion",
    noSubCategory: "Aucune sous-catégorie",
    noCategory: "Aucune catégorie",
    noCourse: "Aucun cours",
    noLevel: "Aucun niveau",
  },
};

// Dashboard
export const DashboardData = {
  en: {
    dailyLessons: "Daily lessons",
    showMoreLessons: "Show more lessons",
    duration: "Duration",
    instructor: "Instructor",
    time: "Time",
    registeredCourses: "Registered courses",
    showMoreCourses: "Show more courses",
    residual: "Residual",
    rateTheLessons: "Rate The Lessons",
    academicAssignment: "Academic assignment",
    received: "Received",
    availableSoon: "Available soon",
    dailySchedule: "Daily schedule",
    tests: "Tests",
    showMoreTests: "Show more tests",
    invoices: "Invoices",
    today: "Today",
    yesterday: "Yesterday",
    tomorrow: "Tomorrow",
    amountDue: "Amount due",
    paymentNotMade: "Payment has not been made yet",
  },
  ar: {
    dailyLessons: "الدروس اليومية",
    showMoreLessons: "عرض المزيد من الدروس",
    duration: "المدة",
    instructor: "مدرب",
    time: "الوقت",
    registeredCourses: "الدورات المسجلة",
    showMoreCourses: "عرض المزيد من الدورات",
    residual: "المتبقي",
    rateTheLessons: "قيم الدروس",
    academicAssignment: "التكليف الأكاديمي",
    received: "تم الاستلام",
    availableSoon: "قريبا",
    dailySchedule: "الجدول اليومي",
    tests: "الاختبارات",
    showMoreTests: "عرض المزيد من الاختبارات",
    invoices: "الفواتير",
    today: "اليوم",
    yesterday: "أمس",
    tomorrow: "غداً",
    amountDue: "المبلغ المستحق",
    paymentNotMade: "لم يتم الدفع بعد",
  },
  fr: {
    dailyLessons: "Leçons quotidiennes",
    showMoreLessons: "Voir plus de leçons",
    duration: "Durée",
    instructor: "Instructeur",
    time: "Heure",
    registeredCourses: "Cours inscrits",
    showMoreCourses: "Voir plus de cours",
    residual: "Résiduel",
    rateTheLessons: "Évaluez les leçons",
    academicAssignment: "Devoir académique",
    received: "Reçu",
    availableSoon: "Disponible bientôt",
    dailySchedule: "Emploi du temps quotidien",
    tests: "Tests",
    showMoreTests: "Voir plus de tests",
    invoices: "Factures",
    today: "Aujourd'hui",
    yesterday: "Hier",
    tomorrow: "Demain",
    amountDue: "Montant dû",
    paymentNotMade: "Le paiement n'a pas encore été effectué",
  },
};

// Courses
export const CoursesData = {
  en: {
    coursesWatched: "Courses I watched",
    completedCourses: "Completed courses",
    currentCourses: "My current courses",
    sortBy: "Sort by",
    latest: "Latest",
    rating: "Rating",
    price: "Price",
    showLess: "Show less",
    showMore: "Show more",
    registerNow: "Register now",
    completed: "Completed",
    continueWatching: "Continue watching",
  },
  ar: {
    coursesWatched: "الدورات التي شاهدتها",
    completedCourses: "الدورات المكتملة",
    currentCourses: "دوراتي الحالية",
    sortBy: "فرز حسب",
    latest: "الأحدث",
    rating: "التقييم",
    price: "السعر",
    showLess: "عرض أقل",
    showMore: "عرض المزيد",
    registerNow: "سجل الآن",
    completed: "مكتمل",
    continueWatching: "متابعة المشاهدة",
  },
  fr: {
    coursesWatched: "Cours que j'ai regardés",
    completedCourses: "Cours terminés",
    currentCourses: "Mes cours en cours",
    sortBy: "Trier par",
    latest: "Dernier",
    rating: "Note",
    price: "Prix",
    showLess: "Afficher moins",
    showMore: "Afficher plus",
    registerNow: "Inscrivez-vous maintenant",
    completed: "Terminé",
    continueWatching: "Continuer à regarder",
  },
};

// Settings
export const SettingsData = {
  en: {
    myProfile: "My Profile",
    save: "Save",
    edit: "Edit",
    personalInfo: "Personal Information",
    educationalStage: "Educational Stage",
    institute: "Institute",
    number: "Number",
    email: "Email Address",
    aboutMe: "About Me",
    currentTime: "Current Time",
    subjects: "Subjects",
    certificates: "Certificates and Achievements",
    degree: "Degree",
    viewCertificate: "View Certificate",
    previousProjects: "Previous Projects and Works",
    viewProject: "View Project",
    reviews: "Reviews and Comments",
    viewAllReviews: "View All Reviews",
  },
  ar: {
    myProfile: "ملفي الشخصي",
    save: "حفظ",
    edit: "تعديل",
    personalInfo: "المعلومات الشخصية",
    educationalStage: "المرحلة الدراسية",
    institute: "المعهد",
    number: "الرقم",
    email: "البريد الإلكتروني",
    aboutMe: "نبذة عني",
    currentTime: "التوقيت الحالي",
    subjects: "المواد الدراسية",
    certificates: "الشهادات والإنجازات",
    degree: "الدرجة العلمية",
    viewCertificate: "عرض الشهادة",
    previousProjects: "المشاريع والأعمال السابقة",
    viewProject: "عرض المشروع",
    reviews: "المراجعات والتعليقات",
    viewAllReviews: "عرض جميع المراجعات",
  },
  fr: {
    myProfile: "Mon Profil",
    save: "Enregistrer",
    edit: "Modifier",
    personalInfo: "Informations personnelles",
    educationalStage: "Niveau scolaire",
    institute: "Institut",
    number: "Numéro",
    email: "Adresse e-mail",
    aboutMe: "À propos de moi",
    currentTime: "Heure actuelle",
    subjects: "Matières",
    certificates: "Certificats et réalisations",
    degree: "Diplôme",
    viewCertificate: "Voir le certificat",
    previousProjects: "Projets et travaux précédents",
    viewProject: "Voir le projet",
    reviews: "Avis et commentaires",
    viewAllReviews: "Voir tous les avis",
  },
};

// Table
export const TableData = {
  en: {
    noResults: "No results.",
    rows: "row(s)",
    previous: "Previous",
    next: "Next",
    columns: "Columns",
    filter: "Filter",
  },
  ar: {
    noResults: "لا توجد نتائج.",
    rows: "صف(وف)",
    previous: "السابق",
    next: "التالي",
    columns: "الأعمدة",
    filter: "فلتر",
  },
  fr: {
    noResults: "Aucun résultat.",
    rows: "ligne(s)",
    previous: "Précédent",
    next: "Suivant",
    columns: "Colonnes",
    filter: "Filtre",
  },
};

// Categories
export const CategoriesData = {
  en: {
    allCategories: "All Categories",
    activeCategories: "Active Categories",
    inactiveCategories: "Inactive Categories",
    categories: "Categories",
    addNewCategory: "Add New Category",
    addCategory: "Add Category",
    editCategory: "Update Category",
    deleteCategory: "Delete Category",
    titleEn: "Title (English)",
    titleAr: "Title (Arabic)",
    descriptionEn: "Description (English)",
    descriptionAr: "Description (Arabic)",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    createdBy: "Created By",
    courseCount: "Course Count",
    actions: "Actions",
    loadingCategories: "Loading Categories",
    categoryCreated: "Category Created",
    categoryUpdated: "Category Updated",
    categoryDeleted: "Category Deleted",
    error: "Error",
    close: "Close",
    confirmDelete:
      "Are you sure you want to delete this category? This action cannot be undone.",
    modifyCategory: "Modify the category details as needed.",
    createCategory: "Easily create and manage a new category.",
    categoriesByTitle: "Categories by Title",
    categoryCreatedDescription:
      "The new category has been successfully added 🎉",
    categoryUpdatedDescription:
      "The category details have been successfully updated ✏️",
    categoryDeletedDescription: "The category has been successfully removed 🗑️",
    Thumbnail: "Thumbnail",
    imageExtensionMessage:
      "Only images with png or jpg extension can be placed.",
    selectStatus: "Select status",
    generalInformation: "General information",
    enterTitleEn: "Enter title in English",
    enterTitleAr: "Enter title in Arabic",
    descriptionArEn: "Description in Arabic & English",
    deleteConfirmationMessage:
      "You are about to delete this category. This action cannot be undone.",
    actionCannotBeUndone: "This action cannot be undone",
    coursesWillBeDeleted: "courses will be permanently deleted",
    allAssociatedContentRemoved:
      "All associated courses and content will be permanently removed from the system.",
    typeDeleteToConfirm: "Type DELETE to confirm:",
    Cancel: "Cancel",
    showMode: "Show Mode",
    editMode: "Edit Mode",
    Thumbnail: "Thumbnail",
    imageExtensionMessage:
      "Only images with png or jpg extension can be placed.",
    Status: "Status",
    selectStatus: "Select status",
    generalInformation: "General information",
    enterTitleEn: "Enter title in English",
    enterTitleAr: "Enter title in Arabic",
    subCategories: "Sub Categories",
  },
  ar: {
    allCategories: "جميع الفئات",
    activeCategories: "الفئات النشطة",
    inactiveCategories: "الفئات غير النشطة",
    categories: "الفئات",
    addNewCategory: "إضافة فئة جديدة",
    addCategory: "إضافة فئة",
    editCategory: "تعديل الفئة",
    deleteCategory: "حذف الفئة",
    titleEn: "العنوان (الإنجليزية)",
    titleAr: "العنوان (العربية)",
    descriptionEn: "الوصف (الإنجليزية)",
    descriptionAr: "الوصف (العربية)",
    status: "الحالة",
    active: "نشط",
    inactive: "غير نشط",
    createdBy: "تم الإنشاء بواسطة",
    courseCount: "عدد الدورات",
    actions: "الإجراءات",
    loadingCategories: "جارٍ تحميل الفئات",
    categoryCreated: "تم إنشاء الفئة",
    categoryUpdated: "تم تحديث الفئة",
    categoryDeleted: "تم حذف الفئة",
    error: "خطأ",
    close: "إغلاق",
    confirmDelete:
      "هل أنت متأكد أنك تريد حذف هذه الفئة؟ لا يمكن التراجع عن هذا الإجراء.",
    modifyCategory: "قم بتعديل تفاصيل الفئة حسب الحاجة.",
    createCategory: "قم بإنشاء وإدارة فئة جديدة بسهولة.",
    categoriesByTitle: "الفئات حسب العنوان",
    categoryCreatedDescription: "تمت إضافة الفئة الجديدة بنجاح 🎉",
    categoryUpdatedDescription: "تم تحديث تفاصيل الفئة بنجاح ✏️",
    categoryDeletedDescription: "تمت إزالة الفئة بنجاح 🗑️",
    Thumbnail: "الصورة المصغرة",
    imageExtensionMessage: "يمكن وضع الصور ذات الامتداد png أو jpg فقط.",
    selectStatus: "اختر الحالة",
    generalInformation: "معلومات عامة",
    enterTitleEn: "أدخل العنوان بالإنجليزية",
    enterTitleAr: "أدخل العنوان بالعربية",
    descriptionArEn: "الوصف بالعربية والإنجليزية",
    deleteConfirmationMessage:
      "أنت على وشك حذف هذه الفئة. لا يمكن التراجع عن هذا الإجراء.",
    actionCannotBeUndone: "لا يمكن التراجع عن هذا الإجراء",
    coursesWillBeDeleted: "سيتم حذف الدورات بشكل دائم",
    allAssociatedContentRemoved:
      "سيتم إزالة جميع الدورات والمحتوى المرتبط بها بشكل دائم من النظام.",
    typeDeleteToConfirm: "اكتب DELETE للتأكيد:",
    Cancel: "إلغاء",
    showMode: "وضع العرض",
    editMode: "وضع التعديل",
    Thumbnail: "الصورة المصغرة",
    imageExtensionMessage: "يمكن وضع الصور ذات الامتداد png أو jpg فقط.",
    Status: "الحالة",
    selectStatus: "اختر الحالة",
    generalInformation: "معلومات عامة",
    enterTitleEn: "أدخل العنوان بالإنجليزية",
    enterTitleAr: "أدخل العنوان بالعربية",
    subCategories: "الفئات الفرعية",
  },
  fr: {
    allCategories: "Toutes les catégories",
    activeCategories: "Catégories actives",
    inactiveCategories: "Catégories inactives",
    categories: "Catégories",
    addNewCategory: "Ajouter une nouvelle catégorie",
    addCategory: "Ajouter une catégorie",
    editCategory: "Modifier la catégorie",
    deleteCategory: "Supprimer la catégorie",
    titleEn: "Titre (Anglais)",
    titleAr: "Titre (Arabe)",
    descriptionEn: "Description (Anglais)",
    descriptionAr: "Description (Arabe)",
    status: "Statut",
    active: "Actif",
    inactive: "Inactif",
    createdBy: "Créé par",
    courseCount: "Nombre de cours",
    actions: "Actions",
    loadingCategories: "Chargement des catégories",
    categoryCreated: "Catégorie créée",
    categoryUpdated: "Catégorie mise à jour",
    categoryDeleted: "Catégorie supprimée",
    error: "Erreur",
    close: "Fermer",
    confirmDelete:
      "Êtes-vous sûr de vouloir supprimer cette catégorie ? Cette action ne peut pas être annulée.",
    modifyCategory: "Modifiez les détails de la catégorie selon vos besoins.",
    createCategory: "Créez et gérez facilement une nouvelle catégorie.",
    categoriesByTitle: "Catégories par titre",
    categoryCreatedDescription:
      "La nouvelle catégorie a été ajoutée avec succès 🎉",
    categoryUpdatedDescription:
      "Les détails de la catégorie ont été mis à jour avec succès ✏️",
    categoryDeletedDescription: "La catégorie a été supprimée avec succès 🗑️",
    Thumbnail: "Vignette",
    imageExtensionMessage:
      "Seules les images avec l'extension png ou jpg peuvent être placées.",
    selectStatus: "Sélectionnez le statut",
    generalInformation: "Informations générales",
    enterTitleEn: "Entrez le titre en anglais",
    enterTitleAr: "Entrez le titre en arabe",
    descriptionArEn: "Description en arabe et en anglais",
    deleteConfirmationMessage:
      "Vous êtes sur le point de supprimer cette catégorie. Cette action ne peut pas être annulée.",
    actionCannotBeUndone: "Cette action ne peut pas être annulée",
    coursesWillBeDeleted: "les cours seront définitivement supprimés",
    allAssociatedContentRemoved:
      "Tous les cours et contenus associés seront définitivement supprimés du système.",
    typeDeleteToConfirm: "Tapez DELETE pour confirmer:",
    Cancel: "Annuler",
    showMode: "Mode Affichage",
    editMode: "Mode Édition",
    Thumbnail: "Vignette",
    imageExtensionMessage:
      "Seules les images avec l'extension png ou jpg peuvent être placées.",
    Status: "Statut",
    selectStatus: "Sélectionnez le statut",
    generalInformation: "Informations générales",
    enterTitleEn: "Entrez le titre en anglais",
    enterTitleAr: "Entrez le titre en arabe",
    subCategories: "Sous-catégories",
  },
};

// Sub Categories
export const SubCategoriesData = {
  en: {
    loadingSubCategories: "Loading Sub Categories",
    subCategoryCreated: "Sub Category Created",
    subCategoryCreatedDescription:
      "The new sub category has been successfully added 🎉",
    addNewSubCategory: "Add New Sub Category",
    addSubCategory: "Add Sub Category",
    createSubCategoryDescription:
      "Easily create and manage a new sub category.",
    Thumbnail: "Thumbnail",
    imageExtensionMessage:
      "Only images with png or jpg extension can be placed.",
    Status: "Status",
    selectStatus: "Select status",
    generalInformation: "General information",
    enterTitleEn: "Enter title in English",
    enterTitleAr: "Enter title in Arabic",
    close: "Close",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    titleEn: "Title (English)",
    titleAr: "Title (Arabic)",
    descriptionEn: "Description (English)",
    descriptionAr: "Description (Arabic)",
    subCategoryDeleted: "Sub Category Deleted",
    subCategoryDeletedDescription:
      "The sub category has been successfully removed 🗑️",
    deleteSubCategory: "Delete Sub Category",
    deleteSubCategoryConfirmation:
      "You are about to delete this sub category. This action cannot be undone.",
    actionCannotBeUndone: "This action cannot be undone",
    subCategoriesWillBeDeleted: "sub categories will be permanently deleted",
    allAssociatedContentRemoved:
      "All associated sub categories and content will be permanently removed from the system.",
    typeDeleteToConfirm: "Type DELETE to confirm:",
    Cancel: "Cancel",
    courseCount: "Course Count",
    subCategoriesByTitle: "Sub Categories by Title",
    updateSubCategory: "Update Sub Category",
    modifySubCategory: "Modify the sub category details as needed.",
    thumbnail: "Thumbnail",
    onlyImages: "Only images with png or jpg extension can be placed.",
    status: "Status",
    selectStatus: "Select status",
    active: "Active",
    inactive: "Inactive",
    generalInformation: "General information",
    titleEn: "Title in English",
    titleAr: "Title in Arabic",
    descriptionAr: "Description in Arabic",
    descriptionEn: "Description in English",
    courses: "Courses",
    error: "Error",
    showMode: "Show Mode",
    editMode: "Edit Mode",
  },
  ar: {
    loadingSubCategories: "جاري تحميل الفئات الفرعية",
    subCategoryCreated: "تم إنشاء الفئة الفرعية",
    subCategoryCreatedDescription: "تمت إضافة الفئة الفرعية الجديدة بنجاح 🎉",
    addNewSubCategory: "إضافة فئة فرعية جديدة",
    addSubCategory: "إضافة فئة فرعية",
    createSubCategoryDescription: "قم بإنشاء وإدارة فئة فرعية جديدة بسهولة.",
    Thumbnail: "الصورة المصغرة",
    imageExtensionMessage: "يمكن وضع الصور ذات الامتداد png أو jpg فقط.",
    Status: "الحالة",
    selectStatus: "اختر الحالة",
    generalInformation: "معلومات عامة",
    enterTitleEn: "أدخل العنوان بالإنجليزية",
    enterTitleAr: "أدخل العنوان بالعربية",
    close: "إغلاق",
    status: "الحالة",
    active: "نشط",
    inactive: "غير نشط",
    titleEn: "العنوان (الإنجليزية)",
    titleAr: "العنوان (العربية)",
    descriptionEn: "الوصف (الإنجليزية)",
    descriptionAr: "الوصف (العربية)",
    subCategoryDeleted: "تم حذف الفئة الفرعية",
    subCategoryDeletedDescription: "تمت إزالة الفئة الفرعية بنجاح 🗑️",
    deleteSubCategory: "حذف الفئة الفرعية",
    deleteSubCategoryConfirmation:
      "أنت على وشك حذف هذه الفئة الفرعية. لا يمكن التراجع عن هذا الإجراء.",
    actionCannotBeUndone: "لا يمكن التراجع عن هذا الإجراء",
    subCategoriesWillBeDeleted: "سيتم حذف الفئات الفرعية بشكل دائم",
    allAssociatedContentRemoved:
      "سيتم إزالة جميع الفئات الفرعية والمحتوى المرتبط بها بشكل دائم من النظام.",
    typeDeleteToConfirm: "اكتب DELETE للتأكيد:",
    Cancel: "إلغاء",
    courseCount: "عدد الدورات",
    subCategoriesByTitle: "الفئات الفرعية حسب العنوان",
    updateSubCategory: "تحديث الفئة الفرعية",
    modifySubCategory: "قم بتعديل تفاصيل الفئة الفرعية حسب الحاجة.",
    thumbnail: "الصورة المصغرة",
    onlyImages: "يمكن وضع الصور ذات الامتداد png أو jpg فقط.",
    status: "الحالة",
    selectStatus: "اختر الحالة",
    active: "نشط",
    inactive: "غير نشط",
    generalInformation: "المعلومات العامة",
    titleEn: "العنوان بالإنجليزية",
    titleAr: "العنوان بالعربية",
    descriptionAr: "الوصف بالعربية",
    descriptionEn: "الوصف بالإنجليزية",
    courses: "الدورات",
    error: "خطأ",
    showMode: "وضع العرض",
    editMode: "وضع التعديل",
  },
  fr: {
    loadingSubCategories: "Loading Sub Categories",
    subCategoryCreated: "Sous-catégorie créée",
    subCategoryCreatedDescription:
      "La nouvelle sous-catégorie a été ajoutée avec succès 🎉",
    addNewSubCategory: "Ajouter une nouvelle sous-catégorie",
    addSubCategory: "Ajouter une sous-catégorie",
    createSubCategoryDescription:
      "Créez et gérez facilement une nouvelle sous-catégorie.",
    Thumbnail: "Vignette",
    imageExtensionMessage:
      "Seules les images avec l'extension png ou jpg peuvent être placées.",
    Status: "Statut",
    selectStatus: "Sélectionnez le statut",
    generalInformation: "Informations générales",
    enterTitleEn: "Entrez le titre en anglais",
    enterTitleAr: "Entrez le titre en arabe",
    close: "Fermer",
    status: "Statut",
    active: "Actif",
    inactive: "Inactif",
    titleEn: "Titre (Anglais)",
    titleAr: "Titre (Arabe)",
    descriptionEn: "Description (Anglais)",
    descriptionAr: "Description (Arabe)",
    subCategoryDeleted: "Sous-catégorie supprimée",
    subCategoryDeletedDescription:
      "La sous-catégorie a été supprimée avec succès 🗑️",
    deleteSubCategory: "Supprimer la sous-catégorie",
    deleteSubCategoryConfirmation:
      "Vous êtes sur le point de supprimer cette sous-catégorie. Cette action ne peut pas être annulée.",
    actionCannotBeUndone: "Cette action ne peut pas être annulée",
    subCategoriesWillBeDeleted:
      "les sous-catégories seront définitivement supprimées",
    allAssociatedContentRemoved:
      "Toutes les sous-catégories et le contenu associé seront définitivement supprimés du système.",
    typeDeleteToConfirm: "Tapez DELETE pour confirmer:",
    Cancel: "Annuler",
    courseCount: "Nombre de cours",
    subCategoriesByTitle: "Sous-catégories par titre",
    updateSubCategory: "Mettre à jour la sous-catégorie",
    modifySubCategory:
      "Modifiez les détails de la sous-catégorie selon les besoins.",
    thumbnail: "Vignette",
    onlyImages:
      "Seules les images avec l'extension png ou jpg peuvent être placées.",
    status: "Statut",
    selectStatus: "Sélectionnez le statut",
    active: "Actif",
    inactive: "Inactif",
    generalInformation: "Informations générales",
    titleEn: "Titre en anglais",
    titleAr: "Titre en arabe",
    descriptionAr: "Description en arabe",
    descriptionEn: "Description en anglais",
    courses: "Cours",
    error: "Erreur",
    showMode: "Mode Affichage",
    editMode: "Mode Édition",
  },
};

// Course
export const CourseData = {
  en: {
    // TableCourse & DrawerAddCourse texts
    loadingCourses: "Loading Courses",
    titleEn: "Title (English)",
    titleAr: "Title (Arabic)",
    createdBy: "Created By",
    levelCount: "Level Count",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    actions: "Actions",
    coursesByTitle: "Courses by Title",
    addCourse: "Add Course",
    easilyCreateAndManageCourse: "Easily create and manage a new Course.",
    thumbnail: "Thumbnail",
    bigImage: "Big Image",
    video: "Video",
    imageExtensionInfo: "Only images with png or jpg extension can be placed.",
    videoExtensionInfo: "Only videos with MP4, WebM extension can be placed.",
    generalInformation: "General Information",
    smallDescription: "Small Description",
    bigDescription: "Big Description",
    enterTitleEn: "Enter title in English",
    enterTitleAr: "Enter title in Arabic",
    selectStatus: "Select Status",
    selectType: "Select Type",
    live: "Live",
    recorded: "Recorded",
    levels: "Levels",
    lessons: "Lessons",
    // Delete dialog texts
    deleteCourse: "Delete Course",
    deleteCourseDialogTitle: "Delete Course",
    deleteCourseDialogDescription:
      "You are about to delete this Course. This action cannot be undone.",
    deleteWarning: "This action cannot be undone",
    levelsWillBeDeleted: "levels will be permanently deleted",
    associatedContentRemoval:
      "All associated levels and content will be permanently removed from the system.",
    typeToConfirm: "Type DELETE to confirm:",
    cancel: "Cancel",
    // Toast and error messages
    courseCreatedToast: "Course Created",
    courseCreatedDescription: "The new course has been successfully added 🎉",
    courseDeletedToast: "Course Deleted",
    courseDeletedDescription: "The course has been successfully removed 🗑️",
    error: "Error",
    // AdminViewCourses additional texts
    updateCourse: "Update Course",
    courseUpdatedToast: "Course Updated",
    courseUpdatedDescription:
      "The course details have been successfully updated ✏️",
    editMode: "Edit Mode",
    showMode: "Show Mode",
  },
  ar: {
    // TableCourse & DrawerAddCourse texts
    loadingCourses: "جاري تحميل الكورسات",
    titleEn: "العنوان (بالإنجليزية)",
    titleAr: "العنوان (بالعربية)",
    createdBy: "تم الإنشاء بواسطة",
    levelCount: "عدد المستويات",
    status: "الحالة",
    active: "نشط",
    inactive: "غير نشط",
    actions: "الإجراءات",
    coursesByTitle: "الدورات حسب العنوان",
    addCourse: "إضافة دورة",
    easilyCreateAndManageCourse: "أنشئ دورة جديدة وقم بإدارتها بسهولة.",
    thumbnail: "الصورة المصغرة",
    bigImage: "صورة كبيرة",
    video: "فيديو",
    imageExtensionInfo: "يمكن استخدام الصور ذات امتداد png أو jpg فقط.",
    videoExtensionInfo: "يمكن استخدام الفيديوهات ذات امتداد MP4 أو WebM فقط.",
    generalInformation: "معلومات عامة",
    smallDescription: "وصف قصير",
    bigDescription: "وصف طويل",
    enterTitleEn: "أدخل العنوان باللغة الإنجليزية",
    enterTitleAr: "أدخل العنوان باللغة العربية",
    selectStatus: "اختر الحالة",
    selectType: "اختر النوع",
    live: "مباشر",
    recorded: "مسجل",
    levels: "المستويات",
    lessons: "الدروس",
    // Delete dialog texts
    deleteCourse: "حذف الدورة",
    deleteCourseDialogTitle: "حذف الدورة",
    deleteCourseDialogDescription:
      "أنت على وشك حذف هذه الدورة. هذا الإجراء لا يمكن التراجع عنه.",
    deleteWarning: "هذا الإجراء لا يمكن التراجع عنه",
    levelsWillBeDeleted: "سيتم حذف المستويات نهائيًا",
    associatedContentRemoval:
      "سيتم إزالة جميع المستويات والمحتوى المرتبط من النظام بشكل نهائي.",
    typeToConfirm: "اكتب DELETE للتأكيد:",
    cancel: "إلغاء",
    // Toast and error messages
    courseCreatedToast: "تم إنشاء الدورة",
    courseCreatedDescription: "تم إضافة الدورة الجديدة بنجاح 🎉",
    courseDeletedToast: "تم حذف الدورة",
    courseDeletedDescription: "تمت إزالة الدورة بنجاح 🗑️",
    error: "خطأ",
    // AdminViewCourses additional texts
    updateCourse: "تحديث الدورة",
    courseUpdatedToast: "تم تحديث الدورة",
    courseUpdatedDescription: "تم تحديث تفاصيل الدورة بنجاح ✏️",
    editMode: "وضع التعديل",
    showMode: "وضع العرض",
  },
  fr: {
    // TableCourse & DrawerAddCourse texts
    loadingCourses: "Loading Courses",
    titleEn: "Titre (Anglais)",
    titleAr: "Titre (Arabe)",
    createdBy: "Créé par",
    levelCount: "Nombre de niveaux",
    status: "Statut",
    active: "Actif",
    inactive: "Inactif",
    actions: "Actions",
    coursesByTitle: "Cours par Titre",
    addCourse: "Ajouter un cours",
    easilyCreateAndManageCourse: "Créez et gérez facilement un nouveau cours.",
    thumbnail: "Vignette",
    bigImage: "Grande image",
    video: "Vidéo",
    imageExtensionInfo:
      "Seules les images au format png ou jpg sont acceptées.",
    videoExtensionInfo:
      "Seules les vidéos au format MP4 ou WebM sont acceptées.",
    generalInformation: "Informations générales",
    smallDescription: "Petite description",
    bigDescription: "Grande description",
    enterTitleEn: "Entrez le titre en anglais",
    enterTitleAr: "Entrez le titre en arabe",
    selectStatus: "Sélectionner le statut",
    selectType: "Sélectionner le type",
    live: "En direct",
    recorded: "Enregistré",
    levels: "Niveaux",
    lessons: "Leçons",
    // Delete dialog texts
    deleteCourse: "Supprimer le cours",
    deleteCourseDialogTitle: "Supprimer le cours",
    deleteCourseDialogDescription:
      "Vous êtes sur le point de supprimer ce cours. Cette action est irréversible.",
    deleteWarning: "Cette action est irréversible",
    levelsWillBeDeleted: "les niveaux seront supprimés définitivement",
    associatedContentRemoval:
      "Tous les niveaux et contenus associés seront définitivement supprimés du système.",
    typeToConfirm: "Tapez DELETE pour confirmer :",
    cancel: "Annuler",
    // Toast and error messages
    courseCreatedToast: "Cours créé",
    courseCreatedDescription: "Le nouveau cours a été ajouté avec succès 🎉",
    courseDeletedToast: "Cours supprimé",
    courseDeletedDescription: "Le cours a été supprimé avec succès 🗑️",
    error: "Erreur",
    // AdminViewCourses additional texts
    updateCourse: "Mettre à jour le cours",
    courseUpdatedToast: "Cours mis à jour",
    courseUpdatedDescription:
      "Les détails du cours ont été mis à jour avec succès ✏️",
    editMode: "Mode édition",
    showMode: "Mode d'affichage",
  },
};

// Level
export const LevelData = {
  en: {
    viewLessons: "View lessons",
    edit: "Edit",
    editLevel: "Edit Level",
    editLevelDescription: "Modify the level details as needed.",
    titleEn: "Title (English)",
    titleAr: "Title (Arabic)",
    description: "Description (English) & Description (Arabic)",
    levelUpdatedToast: "Level Updated",
    levelUpdatedDescription:
      "The level details have been successfully updated ✏️",
    addLevel: "Add Level",
    addLevelDescription: "Easily create and manage a new level.",
    enterTitleEn: "Enter title in English",
    enterTitleAr: "Enter title in Arabic",
    delete: "Delete",
    deleteLevel: "Delete level",
    deleteLevelDialogTitle: "Delete Level",
    deleteLevelDialogDescription:
      "You are about to delete this level. This action cannot be undone.",
    deleteWarning: "This action cannot be undone",
    lessonsWillBeDeleted: "lessons will be permanently deleted",
    associatedContentRemoval:
      "All associated lessons and content will be permanently removed from the system.",
    typeToConfirm: "Type DELETE to confirm:",
    cancel: "Cancel",
  },
  ar: {
    viewLessons: "عرض الدروس",
    edit: "تعديل",
    editLevel: "تعديل المستوى",
    editLevelDescription: "قم بتعديل تفاصيل المستوى حسب الحاجة.",
    titleEn: "العنوان (بالإنجليزية)",
    titleAr: "العنوان (بالعربية)",
    description: "الوصف (بالإنجليزية) & الوصف (بالعربية)",
    levelUpdatedToast: "تم تحديث المستوى",
    levelUpdatedDescription: "تم تحديث تفاصيل المستوى بنجاح ✏️",
    addLevel: "إضافة مستوى",
    addLevelDescription: "أنشئ مستوى جديد وأدره بسهولة.",
    enterTitleEn: "أدخل العنوان باللغة الإنجليزية",
    enterTitleAr: "أدخل العنوان باللغة العربية",
    delete: "حذف",
    deleteLevel: "حذف المستوى",
    deleteLevelDialogTitle: "حذف المستوى",
    deleteLevelDialogDescription:
      "أنت على وشك حذف هذا المستوى. هذا الإجراء لا يمكن التراجع عنه.",
    deleteWarning: "هذا الإجراء لا يمكن التراجع عنه",
    lessonsWillBeDeleted: "سيتم حذف الدروس نهائيًا",
    associatedContentRemoval:
      "سيتم إزالة جميع الدروس والمحتوى المرتبط من النظام بشكل نهائي.",
    typeToConfirm: "اكتب DELETE للتأكيد:",
    cancel: "إلغاء",
  },
  fr: {
    viewLessons: "Voir les leçons",
    edit: "Modifier",
    editLevel: "Modifier le niveau",
    editLevelDescription: "Modifiez les détails du niveau selon les besoins.",
    titleEn: "Titre (Anglais)",
    titleAr: "Titre (Arabe)",
    description: "Description (Anglais) & Description (Arabe)",
    levelUpdatedToast: "Niveau mis à jour",
    levelUpdatedDescription:
      "Les détails du niveau ont été mis à jour avec succès ✏️",
    addLevel: "Ajouter un niveau",
    addLevelDescription: "Créez et gérez facilement un nouveau niveau.",
    enterTitleEn: "Entrez le titre en anglais",
    enterTitleAr: "Entrez le titre en arabe",
    delete: "Supprimer",
    deleteLevel: "Supprimer le niveau",
    deleteLevelDialogTitle: "Supprimer le niveau",
    deleteLevelDialogDescription:
      "Vous êtes sur le point de supprimer ce niveau. Cette action est irréversible.",
    deleteWarning: "Cette action est irréversible",
    lessonsWillBeDeleted: "les leçons seront supprimées définitivement",
    associatedContentRemoval:
      "Tous les leçons et contenus associés seront définitivement supprimés du système.",
    typeToConfirm: "Tapez DELETE pour confirmer :",
    cancel: "Annuler",
  },
};

// Lesson
export const LessonData = {
  en: {
    // TableLessons texts
    titleEn: "Title (English)",
    titleAr: "Title (Arabic)",
    subLessonCount: "Sub Lesson Count",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    actions: "Actions",
    tableTitle: "Lessons by Title",
    // DrawerAddLesson texts
    addLesson: "Add Lesson",
    addLessonDescription: "Easily create and manage a new Lesson.",
    lessonCreatedToast: "Lesson Created",
    lessonCreatedDescription: "The new lesson has been successfully added 🎉",
    thumbnail: "Thumbnail",
    bigImage: "Big Image",
    video: "Video",
    imageExtensionInfo: "Only images with png or jpg extension can be placed.",
    videoExtensionInfo: "Only videos with MP4, WebM extension can be placed.",
    generalInformation: "General information",
    smallDescription: "Small Description",
    bigDescription: "Big Description",
    enterTitleEn: "Enter title in English",
    enterTitleAr: "Enter title in Arabic",
    selectStatus: "Select status",
    status: "Status",
    type: "Type",
    selectType: "Select type",
    live: "Live",
    recorded: "Recorded",
    cancel: "Close",
    // DialogDeleteLessons texts
    deleteLesson: "Delete Lesson",
    deleteLessonDialogTitle: "Delete Lesson",
    deleteLessonDialogDescription:
      "You are about to delete this lesson. This action cannot be undone.",
    deleteWarning: "This action cannot be undone",
    subLessonsWillBeDeleted: "Sub lessons will be permanently deleted",
    associatedContentRemoval:
      "All associated lessons and content will be permanently removed from the system.",
    typeToConfirm: "Type DELETE to confirm:",
  },
  ar: {
    // TableLessons texts
    titleEn: "العنوان (بالإنجليزية)",
    titleAr: "العنوان (بالعربية)",
    subLessonCount: "عدد الدروس الفرعية",
    status: "الحالة",
    active: "نشط",
    inactive: "غير نشط",
    actions: "الإجراءات",
    tableTitle: "الدروس حسب العنوان",
    // DrawerAddLesson texts
    addLesson: "إضافة درس",
    addLessonDescription: "أنشئ درسًا جديدًا وقم بإدارته بسهولة.",
    lessonCreatedToast: "تم إنشاء الدرس",
    lessonCreatedDescription: "تمت إضافة الدرس الجديد بنجاح 🎉",
    thumbnail: "الصورة المصغرة",
    bigImage: "صورة كبيرة",
    video: "فيديو",
    imageExtensionInfo: "يمكن استخدام الصور ذات امتداد png أو jpg فقط.",
    videoExtensionInfo: "يمكن استخدام الفيديوهات ذات امتداد MP4 أو WebM فقط.",
    generalInformation: "معلومات عامة",
    smallDescription: "وصف قصير",
    bigDescription: "وصف طويل",
    enterTitleEn: "أدخل العنوان باللغة الإنجليزية",
    enterTitleAr: "أدخل العنوان باللغة العربية",
    status: "الحالة",
    type: "نوع",
    selectStatus: "اختر الحالة",
    selectType: "اختر النوع",
    live: "مباشر",
    recorded: "مسجل",
    cancel: "إلغاء",
    // DialogDeleteLessons texts
    deleteLesson: "حذف الدرس",
    deleteLessonDialogTitle: "حذف الدرس",
    deleteLessonDialogDescription:
      "أنت على وشك حذف هذا الدرس. هذا الإجراء لا يمكن التراجع عنه.",
    deleteWarning: "هذا الإجراء لا يمكن التراجع عنه",
    subLessonsWillBeDeleted: "سيتم حذف الدروس الفرعية نهائيًا",
    associatedContentRemoval:
      "سيتم إزالة جميع الدروس والمحتوى المرتبط من النظام بشكل نهائي.",
    typeToConfirm: "اكتب DELETE للتأكيد:",
  },
  fr: {
    // TableLessons texts
    titleEn: "Titre (Anglais)",
    titleAr: "Titre (Arabe)",
    subLessonCount: "Nombre de sous-leçons",
    status: "Statut",
    active: "Actif",
    inactive: "Inactif",
    actions: "Actions",
    tableTitle: "Leçons par titre",
    // DrawerAddLesson texts
    addLesson: "Ajouter une leçon",
    addLessonDescription: "Créez et gérez facilement une nouvelle leçon.",
    lessonCreatedToast: "Leçon créée",
    lessonCreatedDescription: "La nouvelle leçon a été ajoutée avec succès 🎉",
    thumbnail: "Vignette",
    bigImage: "Grande image",
    video: "Vidéo",
    imageExtensionInfo:
      "Seules les images au format png ou jpg sont acceptées.",
    videoExtensionInfo:
      "Seules les vidéos au format MP4 ou WebM sont acceptées.",
    generalInformation: "Informations générales",
    smallDescription: "Petite description",
    bigDescription: "Grande description",
    enterTitleEn: "Entrez le titre en anglais",
    enterTitleAr: "Entrez le titre en arabe",
    status: "Statut",
    type: "Type",
    selectStatus: "Sélectionnez le statut",
    selectType: "Sélectionnez le type",
    live: "En direct",
    recorded: "Enregistré",
    cancel: "Annuler",
    // DialogDeleteLessons texts
    deleteLesson: "Supprimer la leçon",
    deleteLessonDialogTitle: "Supprimer la leçon",
    deleteLessonDialogDescription:
      "Vous êtes sur le point de supprimer cette leçon. Cette action est irréversible.",
    deleteWarning: "Cette action est irréversible",
    subLessonsWillBeDeleted: "Les sous-leçons seront définitivement supprimées",
    associatedContentRemoval:
      "Tous les leçons et contenus associés seront définitivement supprimés du système.",
    typeToConfirm: "Tapez DELETE pour confirmer :",
  },
};
